import { type AdminCharges, chargeAudience, toCents } from './chargeSummary'

export const CHARGE_SCOPES = ['customers', 'internal', 'all'] as const
export type ChargeScope = (typeof CHARGE_SCOPES)[number]

export const SCOPE_LABEL: Record<ChargeScope, string> = {
  customers: 'Customers',
  internal: 'Internal',
  all: 'All accounts',
}

export const SCOPE_CHARGED: Record<ChargeScope, string> = {
  customers: 'to customers',
  internal: 'to internal accounts',
  all: 'to all accounts',
}

/** Accounts without a pricing group are unidentified, so they stay with customers. */
function inScope(scope: ChargeScope, pricingGroup?: string | null): boolean {
  if (scope === 'all') return true
  const internal = chargeAudience(pricingGroup) === 'Internal'
  return scope === 'internal' ? internal : !internal
}

/** Buckets by their group at the period, accounts by their current group; the total is re-summed in cents. */
export function scopeCharges(
  charges: AdminCharges,
  scope: ChargeScope,
): AdminCharges {
  if (scope === 'all') return charges
  const buckets = charges.buckets.filter((b) => inScope(scope, b.pricingGroup))
  const cents = buckets.reduce((sum, b) => sum + toCents(b.amountUsd), 0)
  return {
    ...charges,
    buckets,
    accounts: charges.accounts.filter((a) => inScope(scope, a.pricingGroup)),
    totalUsd: (cents / 100).toFixed(2),
  }
}
